const host = globalThis.location?.host ?? ''
const isProd = host === 'comply.clinicallyai.com'

const CNAI_BASE_URL = isProd ? 'https://app.clinicalnotes.ai' : 'https://beta.clinicalnotes.ai'

export const getCNAIUrl = (path: string): string => `${CNAI_BASE_URL}${path}`
